import { UserPlanVo, UserProfile } from "@/api";
import creditIcon from "@/assets/images/credit-icon.png";
import { formatNumberWithCommas } from "@/util/formatNumber";
import Image from "next/image";
import Link from "next/link";
import React from "react";

interface CreditPlanLinkProps {
  userLoading: boolean;
  user: UserProfile | null;
  userPlan: UserPlanVo | null;
  userCredits: number;
  variant: "desktop" | "mobile";
}

export const CreditPlanLink: React.FC<CreditPlanLinkProps> = ({
  userLoading,
  user,
  userPlan,
  userCredits,
  variant,
}) => {
  if (userLoading) {
    return null;
  }

  if (variant === "mobile" && !user) {
    return null;
  }

  const className =
    variant === "mobile"
      ? "flex items-center gap-1.5 px-3 py-2 font-medium rounded-full border border-text-primary/[.07] bg-black/20 backdrop-blur-xl text-text-primary cursor-pointer transition-all hover:bg-primary/[.15] hover:backdrop-blur-none"
      : "flex items-center gap-2 px-4 py-2 font-medium rounded-full border border-text-primary/[.07] bg-black/20 backdrop-blur-xl text-text-primary cursor-pointer transition-all hover:bg-primary/[.15] hover:backdrop-blur-none";

  return (
    <Link
      href="/pricing"
      className={variant === "desktop" ? "text-text-primary!" : undefined}
      data-disable-progress={true}
    >
      <div className={className}>
        {variant === "mobile" ? (
          <>
            <Image src={creditIcon} alt="Credit" width={14} height={14} />
            <span className="text-sm">
              {formatNumberWithCommas(userCredits)}
            </span>
          </>
        ) : user ? (
          <>
            <span className="flex items-center gap-2">
              <Image src={creditIcon} alt="Credit" width={14} height={14} />
              <span>{formatNumberWithCommas(userCredits)}</span>
            </span>
            <div className="w-px h-[15px] bg-white/60"></div>

            <span>{userPlan ? userPlan.memberShipName : user ? "" : "Free"}</span>
          </>
        ) : (
          "Pricing"
        )}
      </div>
    </Link>
  );
};
